// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"S3-z"};